import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { observer } from 'mobx-react';

import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';

@observer
export default class PrivateRoute extends React.Component<RouteProps, {}> {
  @inject(UiStore) private uiStore: UiStore;

  render() {
    if (this.uiStore.isLoggedIn) {
      return (<Route {...this.props} />);
    } else {
      return (
        <Redirect to={{
          pathname: '/login',
          state: { from: this.props.location }
        }}/>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/PrivateRoute.tsx